import React, { useEffect, useMemo } from "react";
import { useMephistoReview } from "../../shims/mephisto-review-hook";
import { Select } from "@blueprintjs/select";
import {
  Button
} from "@blueprintjs/core";
import { DEFAULT_THEME } from '../Loaders/ThemeLoader';

import useAtomWithUrlParam from "../../hooks/useAtomWithUrlParam";
// import { useRecoilState } from 'recoil';
// import { versionState } from '../../atoms';

import "./VersionSelector.scss"
import { versionAtom, versionAtomDefault } from "../../atoms";

const LOCAL_VERSION_KEY = 'last-version';

const getSearchParam = (paramName) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
};

function VersionSelector({ validVersions }) {
  const [version, setVersion] = useAtomWithUrlParam(versionAtom, versionAtomDefault);

  const { versionList } = useMephistoReview();

  function setVersionAndStore(version) {
    localStorage.setItem(LOCAL_VERSION_KEY, version);
    setVersion(version);
    document.documentElement.style.setProperty('--app-primaryColor', versionColormap[version] ?? DEFAULT_THEME['--app-primaryColor']);
  }

  const versionColormap = useMemo(() => {
    if (versionList === undefined) {
      return {};
    }
    let out = {}
    versionList.forEach((vobj) => {
      if (vobj.color) {
        out[vobj.name] = vobj.color
      } else {
        out[vobj.name] = 'var(--app-primaryColor)'
      }
    });
    return out
  }
    , [versionList])

  useEffect(() => {
    const lastVersion = localStorage.getItem(LOCAL_VERSION_KEY);
    const versionNames = (versionList ?? []).map(vobj => vobj.name);
    const eligibleVersions = validVersions ? validVersions : versionNames;
    (eligibleVersions ?? []).includes(lastVersion) && !getSearchParam('v') && setVersion(lastVersion);
  }, [versionList])

  const versionNames = (versionList ?? []).map(vobj => vobj.name);

  const selectableVersions = validVersions === undefined ? (versionNames ?? []).sort() :
    (versionNames ?? []).filter(x => validVersions.includes(x)).sort()
  const enabled = selectableVersions && selectableVersions.length > 1;

  return <Select
    className={'version-selector' + (enabled ? '' : ' disabled')}
    disabled={!enabled}
    filterable={false}
    popoverProps={{ minimal: true }}
    items={selectableVersions}
    activeItem={version}
    itemRenderer={(x, { handleClick, modifiers, index }) =>
      <div
        key={x}
        className={'version-option' + (modifiers.active ? ' active' : '')}
        onClick={handleClick}
        onKeyDown={(e) => e.key === 'Enter' && handleClick.bind(this)}
        role='button'
        style={{ color: versionColormap[x] ?? 'var(--app-primaryColor)' }}
        tabIndex={index}>
        {x}
      </div>}
    onItemSelect={(x) => setVersionAndStore(x)}>

    <Button text={version} rightIcon="caret-down" style={{ color: versionColormap[version] ?? 'var(--app-primaryColor)' }} />
  </Select>;
}

export { VersionSelector };